<script>export let breadcrumbs;
export let siteUrl;
$:
  canonicalUrl = siteUrl + breadcrumbs.filter((i) => i.canonical).map((i) => i.slug.replace("/", "")).join("/");
</script>

<svelte:head>
  <link rel="canonical" href="{canonicalUrl}" />
</svelte:head>
